
import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

interface PageLayoutProps {
  children: ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
    
    // Force a refresh when the component mounts
    const isNewTabOrWindow = !document.referrer.includes(window.location.host);
    
    if (isNewTabOrWindow) {
      console.log('New tab or window detected, forcing refresh');
      // Add a small delay to ensure all resources are properly loaded
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
    
    // Log navigation type for debugging
    if (window.performance) {
      const navigationEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
      if (navigationEntry) {
        console.log(`Navigation type: ${navigationEntry.type}`);
      } else if (performance.navigation) {
        // Legacy API fallback
        if (performance.navigation.type === 1) {
          console.log('Page was refreshed');
        } else if (performance.navigation.type === 0) {
          console.log('Page was loaded for the first time');
        }
      }
    }
  }, [pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow pt-16 animate-fade-in">
        {children}
      </main>
      <Footer />
    </div>
  );
}
